<template>
  <div>
    <div class="container is-fluid banner-section bg-img">
      <p class="pb-banner-title">
        CAREER
      </p>
      <span class="yellow-line"></span>
    </div>



    <!-- Unlock Potential -->
    <div class="container is-fluid px-0 mb-6 unlock-potential-section">
      <div class="pb-title colour-primary-01">JOIN US</div>
      <div class="unlockPotential">
        <div class="mt-6" style="margin-bottom: 4rem;">
          <div class="columns reverse-columns">
            <div class="column is-5-desktop left " style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
              <div class="text-box has-text-left">
                <h2 class="section-tag-title colour-primary-02" v-html="staticDataList.top_section_tag"></h2>
                <h1 class="pb-title mobile-title colour-primary-01 colour-background-text-white my-5" v-html="staticDataList.top_section_title"></h1>
                <p class="pb-description colour-primary-03 colour-background-text-white" style="white-space: pre-line" v-html="staticDataList.top_section_desc"></p>
              </div>
            </div>
            <div class="column is-7-desktop right">
              <img src="@/assets/img/career-2-unlock-your-potential.jpg" class="carousel-image"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Our Culture -->
    <div class="container is-fluid px-0 mt-6">
      <div class="section-value">
        <div class="bg-white">
          <div class="columns is-12 is-multiline is-mobile is-tablet is-desktop mt-5 mb-0 mx-0">
            <div class="column is-6-desktop is-12-mobile is-12-tablet p-0 left">
              <img class="value-img" src="@/assets/img/career-3-our-culture.jpg"/>
            </div>
            <div class="column is-4-desktop culture-padding right" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
              <div class="text-box has-text-left">
                <h1 class="pb-title mobile-title colour-primary-01 colour-background-text-white my-5">Our Culture</h1>
                <p class="pb-description colour-primary-03 colour-background-text-white" style="white-space: pre-line" v-html="staticDataList.culture_desc"></p>
                <router-link :to="{ name: 'about-us'}">
                  <b-button type="" class="button button-secondary-background mt-5">
                    <div>Learn More <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                  </b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Our Qualities -->
    <div class="section qualities-section" style="padding-right: 160px; padding-left: 160px; background: #DEDEDE;">
      <h1 class="pb-title pl-0 mb-4 colour-text-darker">Our Qualities</h1>
      <p class="" v-html="staticDataList.qualities_desc"></p>
      <div class="columns mt-5 mb-0 mx-6">
        <div class="column is-4 value-items">
          <div class="card-image">
            <figure class="py-4">
              <img src="@/assets/icons/thumbs-up.png">
              <p class="pt-5" v-html="staticDataList.qualities_box1"></p>
            </figure>
          </div>
        </div>
        <div class="column is-4 value-items">
          <div class="card-image">
            <figure class="py-4">
              <img src="@/assets/icons/jobseeker.png">
              <p class="pt-5" v-html="staticDataList.qualities_box2"></p>
            </figure>
          </div>
        </div>
        <div class="column is-4 value-items">
          <div class="card-image">
            <figure class="py-4 mt-3">
              <img src="@/assets/icons/handshake.png">
              <p class="pt-5" v-html="staticDataList.qualities_box3"></p>
            </figure>
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns mt-5 mb-0 mx-4">
        <div class="column is-2 is-offset-3 value-items">
          <div class="card-image">
            <figure class="py-4">
              <img src="@/assets/icons/worker.png">
              <p class="pt-5" v-html="staticDataList.qualities_box4"></p>
            </figure>
          </div>
        </div>
        <div class="column is-6 value-items">
          <div class="card-image">
            <figure class="py-4">
              <img src="@/assets/icons/goal.png">
              <p class="pt-5" v-html="staticDataList.qualities_box5"></p>
            </figure>
          </div>
        </div>
        <div class="column is-2 is-hidden-desktop"></div>
      </div>
    </div>

    <!-- Join the team -->
    <div class="pl-0 has-text-center bg-white pb-6 join-us-column">
      <div class="pb-title has-text-center pt-6 pb-6 mb-4">
        JOIN THE TEAM
      </div>
      <div class="columns has-text-left mx-0">
        <div class="column is-three-quarters mx-auto form-container">
          <validation-observer v-slot="{ handleSubmit, invalid }">
            <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
              <b-field horizontal class="mb-5" label="First Name" :type="{ 'is-danger': errors[0] }" custom-class="is-medium" :message="errors[0]">
                <b-input v-model="inputFirstName" placeholder="Enter your First Name"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
              <b-field label="Last Name" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]" horizontal>
                <b-input v-model="inputLastName" placeholder="Enter your Last Name"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true, email: true}" v-slot="{ errors }">
              <b-field horizontal label="Email Address" class="mb-5" custom-class="is-medium" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <b-input type="text" v-model="inputEmail" placeholder="Enter your Email Address"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true, integer: true, minPhone: 10, maxPhone: 11}" v-slot="{ errors }">
              <b-field horizontal label="Contact No." class="mb-5" custom-class="is-medium" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                  <b-input v-model="inputPhoneNo" placeholder="Enter your Contact Number" style="max-height: 40px;"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true}" v-slot="{ errors }">
              <b-field horizontal label="Country" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <b-select placeholder="Select your Country" v-model="inputCountry" :loading="loading" :disabled="loading">
                    <option style="color: #7A7A7A !important" value="" disabled selected>Select your Country</option>
                    <option
                        v-for="country in countries"
                        :value="country"
                        :key="country.id">
                        {{ country}}
                    </option>
                </b-select>
                </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true, minCity: 3}" v-slot="{ errors }">
              <b-field horizontal label="City" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <b-select placeholder="Select your City" v-model="inputCity" :loading="loading" :disabled="loading">
                    <option style="color: #7A7A7A !important" value="" disabled selected>Select your City</option>
                    <option
                        v-for="city in cities"
                        :value="city"
                        :key="city.id">
                        {{ city }}
                    </option>
                </b-select>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: false}" v-slot="{ errors }">
              <b-field label="Upload Resume/CV" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]" horizontal>
                <b-upload v-model="file" class="file-label">
                  <span class="file-cta mr-3">
                      <span class="file-label pr-3">Click to upload</span>
                      <b-icon class="file-icon" icon="file-upload-outline"></b-icon>
                  </span>
                  <span class="pt-2" v-if="file">
                      {{ file.name }}
                  </span>
              </b-upload>
              </b-field>
            </validation-provider>

            <div class="captcha-wrapper">
              <div class="mb-6">
                <p class="events-marker">
                  Please attach your relevant files.
                </p>
                <p class="events-marker">
                  • Up to 2MB per file.•
                </p>
                <p class="events-marker">
                  • File formats are pdf/jpg/png only •
                </p>
              </div>
              <VueRecaptcha
                ref="recaptcha"
                :sitekey=sitekey
                :load-recaptcha-script="true"
                @verify="handleSuccess"
                @error="handleError"
                @expired="handleExpired"
                class="mb-2 captcha-contact"
              ></VueRecaptcha>
              <b-button type="submit" class="button dark-red mt-5" @click="handleSubmit(onSubmit(invalid))" icon-right="play" :disabled="invalid || !isVerify">Submit Application</b-button>
            </div>
            <div class="overlay">
              <img class="overlay-image career-img is-hidden-touch" src="@/assets/img/career-4-form.png" />
            </div>
          </validation-observer>
        </div>
      </div>
      <div class="is-flex is-justify-content-end">
        <ScrollTop />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import { VueRecaptcha } from 'vue-recaptcha';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import "@/pages/vee-validate.js";
import ScrollTop from '../components/ScrollTop.vue'

  export default defineComponent({
    components: { ValidationProvider, ValidationObserver, VueRecaptcha, ScrollTop },
    data() {
      return {
        file: {},
        inputFirstName: '',
        inputLastName: '',
        inputEmail: '',
        inputPhoneNo: '',
        inputCity: '',
        isVerify: false,
        hideNavBar: false,
        hideDropdownItem: false,
        closeSearchField: false,
        inputCountry: '',
        countries: [],
        cities:[],
        staticDataList: [],
        homepageStaticData: [],
        qualities: [],
        loading: true,
      };
    },
    async mounted(){
      window.scrollTo(0, 0);
      this.fetchCountryList();
      this.fetchStaticDataList();
    },
    methods: {
      async fetchCountryList(){
        const loadingComponent = this.$buefy.loading.open();
        
        await this.$httpClient({
          method: 'GET',
          url: '/internal/onboarding/form/lookups'
        })
        .then((res) => {
          let response = res.data;
          // Get the country List
          let countriesList = response.Country.map((i) => i.Name);
          this.$set(this, "countries", countriesList);
          // Get the city List
          let citiesList = response.Postcode.map((i) => i.PostalCode + ',' + ' '+ i.PlaceName)
          this.$set(this, "cities", citiesList);
          this.loading = false;
        })

        loadingComponent.close()
      },
      fetchStaticDataList(){
        this.$httpClientCMS({       // GET career static data
          method: 'GET',
          url: 'api/static-fields-career'
        })
        .then(resp => {
          let data = resp.data.data.attributes;
          this.$set(this, 'staticDataList', data);
          this.qualities[0] = data.qualities_box1;
          this.qualities[1] = data.qualities_box2;
          this.qualities[2] = data.qualities_box3;
          this.qualities[3] = data.qualities_box4;
          this.qualities[4] = data.qualities_box5;
        })
        .catch((error) => {
          this.$router.push('maintenance');
        });
        this.$httpClientCMS({       // GET homepage static data
          method: 'GET',
          url: 'api/static-fields-homepage'
        })
        .then(resp => {
          let data = resp.data.data.attributes;
          this.$set(this, 'homepageStaticData', data);
        })
        .catch((error) => {
          this.$router.push('maintenance');
        });
      },
      onSubmit(value) {
        let fileSize = this.file.size / 1000 / 1000; // in MB
        if(this.inputCountry === 'Select your country') {
          this.inputCountry = '';
        }
        if(value === false && fileSize > 2){
          this.displayToast('File size exceeds 2 MB', 'is-danger');
        }else if(value === false && this.isVerify === false){
          this.displayToast('Invalid Captcha', 'is-danger');
        }else if(value === false && this.isVerify === true){
          let upload = new FormData();
          upload.append("files", this.file);
          const formData = {
            first_name: this.inputFirstName,
            last_name: this.inputLastName,
            email: this.inputEmail,
            phone_number: this.inputPhoneNo,
            country: this.inputCountry,
            city: this.inputCity
          };
          if(this.file.size !== undefined){   // store resume in CMS first
            let upload = new FormData();
            upload.append("files", this.file);

            axios.post(process.env.VUE_APP_CMS_URL + "/api/upload",upload,
            {
              headers: { Authorization: "Bearer " + '1b54e10cc82beae1d39ecfa02639bb40966b184ad6138d10577ce3469b67db66aae01787b409ff9ac8d21871b3ee80ff9e6b46265eca63a97d29215d88e00234721d143d218ca57add6fc4bf02196e5344670632d533d5271dca1582befa712cb21d6fc3036778c42adc50b7c0bd8d2162c6ea8b6422baeda71571f140780798' }
            })
            .then((response) => {
              const fileId = response.data[0].id
              formData.resume = fileId;
              this.storeFormData(formData);    // store the entire form data in CMS
            })
            .catch((error)=>{
              console.log(error)
            })
          }else{this.storeFormData(formData);}
        }
      },
      storeFormData(formData){
        axios.post(process.env.VUE_APP_CMS_URL + "/api/entry-careers",
        { data: formData },
        {
          headers: { Authorization: "Bearer " + '1b54e10cc82beae1d39ecfa02639bb40966b184ad6138d10577ce3469b67db66aae01787b409ff9ac8d21871b3ee80ff9e6b46265eca63a97d29215d88e00234721d143d218ca57add6fc4bf02196e5344670632d533d5271dca1582befa712cb21d6fc3036778c42adc50b7c0bd8d2162c6ea8b6422baeda71571f140780798' }
        })
        .then(resp => {
          this.displayToast('Form submitted successfully', 'is-success');
          location.reload();
        })
        .catch((error) => {
          this.displayToast('Failed to submit form', 'is-danger');
        });
      },
      displayToast(message, type){
        this.$buefy.toast.open({
            message: message,
            type: type
        })
      },
      handleSuccess() {
        this.isVerify = true;
      },
      handleError() {
        alert('Server error!');
      },
      handleExpired() {
        this.$refs.recaptcha.reset();
      }
    },
    computed: {
      sitekey(){
        return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
      }
    }
  });
</script>

<style lang="scss" scoped>
@import './styles/font.scss';
.value-img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.events-marker{
  color: #575757;
}

.file-cta {
  border-radius: 0 !important;
}

.banner-section {
  background: url('../assets/img/banner/career.jpg') center;
}

//banner
// .banner-section {
//   padding-block: 25rem;
//   min-height: 950px;
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-end;
//   background-size: cover;
//   background-repeat: no-repeat;
//   margin-top: -10rem;
// }

.unlock-potential-section{
  margin-top: 4rem;
}

// Unlock potential
.unlockPotential {
  background-color: #FFFFFF;
  position: relative;
  margin-top: 4rem;
  margin-bottom: 6.5rem;

  .columns {
    height: 532px;
  }
  .column {
    &.left {
      padding-left: 15.319vw;
      padding-right: 0rem;
      background-color: #FFF;
    }
    .section-tag-title{
      font-weight: 600;
      font-size: 1.125rem;
      line-height: 27px;
      letter-spacing: 0.01em;
      text-transform: capitalize !important;
    }

    &.right {
      padding: 0;
      img {
        height: 100%;
        padding-left: 6rem;
      }
    }
  }

  .carousel-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// Our culture
.culture-section{
  .our-culture {
    margin: 5rem 0;
  }

  .columns {
    height: 532px;
  }

  .column.right {
    // padding: 0 7rem
    padding-right: 14.468vw;
    padding-left: 1.702vw;
  }

  .column.left {
    img {
      object-fit: cover;
      height: 100%;
      max-height: 532px;
      width: 100%;
      padding-right: 8rem;
    }
  }
}

.column.right {
  display: flex;
  flex-wrap: wrap;
  padding-left: 6rem;
}

.captcha-wrapper {
  max-width: 350px;
  text-align: left;
  margin-left: 18%;
}

.captcha-contact{
  transform:scale(0.8);
  -webkit-transform:scale(0.8);
  transform-origin:0 0;
  -webkit-transform-origin:0 0;
}

.join-us-column{
  position: relative;
  overflow: hidden;
}

.overlay{
  position: absolute;
  right: 0;
  bottom: 0;
}

.overlay-image{
  position: relative;
  height: 355px;
  max-height: 100%;
  bottom: -0.5rem;
}

.career-img{
  align-self: flex-end;
  right: 8rem;
}

@media (min-width: 1661px){

  .form-container{
    margin-bottom: 10rem;
  }

  .career-img{
    right: 2rem;
  }
  .overlay-image{
    position: relative;
    height: 624px;
    max-height: 100%;
    bottom: -0.5rem;
  }
}


@media(min-width: 1024px) and (max-width: 1500px) {
  .unlockPotential {
    .columns {
      height: 450px !important;
    }
    .column {
      &.left {
        padding-left: 15.319vw;
      }
    }
  }
  .culture-section {
    .columns {
      height: 450px !important;
    }
    .column {
      &.right {
        // padding: 0 3rem;
        padding-right: 14.468vw;
        padding-left: 1.702vw;
      }

      &.left {
        img {
          max-height: 450px;
          height: 100%;
        }
      }
    }
  }
}

@media screen and (max-width:1290px) and (min-width: 1024px){

  .qualities-section{
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .join-us-column{
    padding-left: 45px !important;
    padding-right: 40px !important;
  }

  .unlockPotential{
    .column {
      &.left {
        padding-left: 10vw;
        padding-right: 0rem;
        background-color: #FFF;
      }
    }
  }

  .overlay-image{
    position: relative;
    height: 340px;
    max-height: 100%;
  }

  .career-img{
    right: 7rem;
  }
}


@media screen and (max-width: 1023px) {
  .banner-section {
    background-position: right 30% center !important;
  }

  .unlock-potential-section{
    margin-top: 3rem;
  }

  .unlockPotential {
    .columns {
      height: 100%;
    }

    .column.left {
      padding: 2rem;
    }
  }

  .culture-section {
    .our-culture {
      margin: 3rem 0;
    }

    .columns {
      height: auto;
    }

    .column {
      &.left {
        img {
          width: 100%;
          max-height: 400px;
        }
      }

      &.right {
        font-size: 1rem;
        min-height: 300px;
        padding: 2rem;
      }

    }
    .our-value-box {
      padding: 3rem 1rem 6rem;
    }
  }

  .column.right {
    display: flex;
    flex-wrap: wrap;
    padding-left: 2rem;
  }

  .unlockPotential {
      .columns {
        height: 100%;
      }

      .column.left {
        padding: 2rem;
      }

      .column.right {
        // padding: 2rem;
      }

      .column.right img {
        padding-left: 0;
      }

      :deep() {
        .carousel-1, .carousel {
          margin-left: 0 !important;
          margin-right: 0 !important;

          .left {
            margin-top: 0;
          }
        }
      }

    }

    .culture-section {
      .understand-our-value {
        margin: 3rem 0;
      }

      .columns {
        height: auto;
      }

      .column {
        &.left {
          img {
            width: 100%;
            max-height: 400px;
            padding-right: 0;
          }
        }

        &.right {
          font-size: 1rem;
          min-height: 300px;
          padding: 2rem;
        }

      }


      .our-value-box {
        padding: 3rem 1rem 6rem;
      }
    }


  .reverse-columns {
    flex-direction: column-reverse;
    display: flex;
  }

  .join-us-column{
    padding-left: 10px !important;
    padding-right: 20px !important;
  }
}

@media screen and (max-width: 1023px) and (min-width: 769px) {

  .qualities-section{
    padding-left: 40px !important;
    padding-right: 40px !important;
  }

  .captcha-wrapper {
    max-width: 298px;
    text-align: left;
    margin-left: 19%;
  }
}

@media screen and (max-width: 945px) and (min-width: 769px) {
  .career-img{
    right: 0.5rem;
  }
}

@media screen and (max-width:768px){
  // .banner-section {
  //   height: 600px;
  //   justify-content: flex-end;
  //   align-items: flex-end;
  //   padding: 0 2.5rem 20rem;
  // }
  .unlockPotential {
    .column.left {
      padding-top: 4rem !important;
    }
  }

  .captcha-wrapper {
    margin-left: 0;
    .captcha-contact {
      margin: 2rem 0;
    }
  }

  .qualities-section{
    padding-left: 40px !important;
    padding-right: 40px !important;
  }

}

@media screen and (max-width:380px){
  .mobile-title{
    font-size: 1.5rem;
  }

  .culture-padding{
    padding-bottom: 3rem;
    padding-left: 1.25rem !important;
  }

  .unlockPotential {
    background-color: #FFFFFF;
    position: relative;
    margin-top: 4rem;
    margin-bottom: 4rem;

    .column.left {
      padding-top: 1rem !important;
    }
  }

  // .banner-section {
  //   min-height: 600px;
  //   padding-block: 12rem;
  //   padding: 4px 0.5rem 11rem;
  // }

  .culture-section {

    .column {
      &.left {
        img {
          width: 100%;
        }
      }

      &.right {
        font-size: 1rem;
        padding: 2rem !important;
      }
    }
  }
}
</style>
